export default __webpack_public_path__ + "locales/sr-Latn-RS/ChangePasswordDialog.json?hash=37b763fd8ae55c305ab58522c789a167";